import React from "react";
import Modal from "Components/smallModal/smallModal";
import Button from "Components/button/Button";
import Input from "Components/input/Input";
import request from "../../config";
import withFormState from "Components/withFormState";
import PropTypes from "prop-types";
import { alertSuccess, alertError } from "Utils/alerts";
import PasswordGenerator from "Components/PasswordGenerator";
import TranslatedString from "Components/TranslatedString";
import { t } from "i18next";
import cx from "classnames";
import s from "./firstLoginModal.scss";

const propTypes = {
  opened: PropTypes.bool,
  handleClose: PropTypes.func,
  handleCodeVerification: PropTypes.func,
  setSession: PropTypes.func,
  isFormSubmitting: PropTypes.bool
};

class FirstLoginModal extends React.Component {
  constructor(props) {
    super(props);
    this.fillPasswordFields = this.fillPasswordFields.bind(this);
    this.state = {
      isVerifing: false
    };
  }

  fillPasswordFields(generatedPassword) {
    this.props.setFormFieldValue({
      password: generatedPassword,
      password_confirmation: generatedPassword
    });
  }

  loginUser(resp) {
    const loggedUser = resp.data.resources[0];
    this.props.setSession(loggedUser);
  }

  validate({ password, password_confirmation }) {
    let errors = {};
    if (password.length < 8) errors.password = "is too short";
    if (password_confirmation !== password) errors.password_confirmation = "is not the same";
    return errors;
  }

  setPassword(e) {
    e.preventDefault();
    const { formData, setFormErrors, setFormLoading, unsetFormLoading } = this.props;
    setFormLoading();
    const errors = this.validate(formData);
    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      unsetFormLoading();
    } else {
      const config = {
        method: "POST",
        url: "/users/login",
        data: {
          ...this.props.formData,
          email_address: this.props.email_address,
          reset_password: true,
          old_password: this.props.oldPassword
        }
      };
      request(config)
        .then(resp => {
          this.props.unsetFormLoading();
          this.props.setSession(resp.data.resources[0]);
          alertSuccess(t("alert.password.updated"));
        })
        .catch(e => {
          this.props.unsetFormLoading();
          alertError(t("alert.wrong"));
          if (e instanceof Error) throw e;
        });
    }
  }

  resetAndClose() {
    this.props.resetForm();
    this.props.handleClose();
  }

  render() {
    const { opened, setFormFieldValue, formData, formErrors, isFormLoading } = this.props;
    return (
      <Modal
        title={t("modal.firstLogin.password.title")}
        opened={opened}
        closeModal={this.resetAndClose.bind(this)}
        withForm
      >
        <form className={s.form} method="post" onSubmit={this.setPassword.bind(this)}>
          <div className={s.wrapInputs}>
            <div>
              <TranslatedString subs={{ emailAccount: this.props.email_address }}>
                modal.firstLogin.password.desc
              </TranslatedString>
            </div>

            <Input
              className={s.input}
              label={t("input.label.password.new")}
              name="password"
              type="password"
              onChange={setFormFieldValue}
              value={formData.password}
              errors={formErrors.password}
            />

            <Input
              className={s.input}
              label={t("input.label.passwordConfirm.new")}
              name="password_confirmation"
              type="password"
              onChange={setFormFieldValue}
              value={formData.password_confirmation}
              errors={formErrors.password_confirmation}
            />

            <PasswordGenerator onNewPassword={this.fillPasswordFields} />
          </div>
          <div className={s.footerBtn}>
            <Button kind="standard" id="login" type="submit" loading={isFormLoading}>
              button.save
            </Button>
          </div>
        </form>
      </Modal>
    );
  }
}
//FirstLoginModal.propTypes = propTypes;

export default withFormState(FirstLoginModal, { password: "", password_confirmation: "" });
